import { render, staticRenderFns } from "./FormCheckBox.vue?vue&type=template&id=dd76f34c&scoped=true&"
import script from "./FormCheckBox.vue?vue&type=script&lang=js&"
export * from "./FormCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./FormCheckBox.vue?vue&type=style&index=0&id=dd76f34c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd76f34c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
